import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'
import * as VueGoogleMaps from 'vue2-google-maps'

import "../css/whence-bootstrap.scss"

import Main from '../vue/components/whence/main.vue'

Vue.use(BootstrapVue)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD6L0XavXrhf-HzZY_5x-ZfQGzplxdz2FU',
    libraries: 'geometry'
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
})

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue({
    render: h => h(Main)
  }).$mount()
  document.body.appendChild(app.$el)
})